var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  stroke: "#2F1F19",
  strokeWidth: 0.6,
  d: "M10.37 8.3a.233.233 0 0 1-.02-.32l2.85-3.23.01-.02c.06-.08.2-.1.28 0v.02l2.83 3.23c.06.08.07.22-.03.33-.07.06-.2.07-.3-.04l-1.91-2.2-.53-.61v9.64c0 .13-.1.23-.22.23a.23.23 0 0 1-.21-.23V5.46l-.53.6-1.92 2.22c-.08.09-.22.1-.3.03ZM6.8 15.24c-.07.08-.11.1-.14.1-.04 0-.1-.03-.19-.1L3.68 12c-.06-.07-.07-.21.03-.33.07-.06.2-.07.3.04l1.91 2.2.53.61V4.87c0-.11.08-.2.22-.2.1 0 .21.1.21.23v9.62l.53-.6 1.92-2.22.01-.01.01-.02.02-.02a.2.2 0 0 1 .07-.02c.04-.01.1-.01.2.05.08.08.08.24.01.32z"
})));
export default SvgIconSort;